import React, { useMemo } from 'react';

const NOW_YEAR = new Date().getFullYear();
const NOW_YM   = `${NOW_YEAR}${String(new Date().getMonth() + 1).padStart(2, '0')}`;
const WEEKDAYS = ['일', '월', '화', '수', '목', '금', '토'];

const todayStr = () => new Date().toISOString().slice(0, 10);

const formatDay = dateStr => {
  const d   = new Date(dateStr);
  const dow = WEEKDAYS[d.getUTCDay()];
  const [y, m, day] = dateStr.split('-');
  return `${y}년 ${m}월 ${day}일 (${dow})`;
};

const prevYm = ym => {
  const y = parseInt(ym.slice(0, 4));
  const m = parseInt(ym.slice(4));
  return m === 1 ? `${y - 1}12` : `${y}${String(m - 1).padStart(2, '0')}`;
};

const nextYm = ym => {
  const y = parseInt(ym.slice(0, 4));
  const m = parseInt(ym.slice(4));
  return m === 12 ? `${y + 1}01` : `${y}${String(m + 1).padStart(2, '0')}`;
};

export default function PeriodTabs({
  period,           // 'today' | 'month' | 'year' | 'custom'
  navDate,          // YYYY-MM-DD
  navYm,            // YYYYMM
  navYear,          // number
  customStart,      // YYYYMM
  customEnd,        // YYYYMM
  customQueried,    // bool
  minBuyYear,       // number|null
  onPeriodChange,
  onNavDateChange,
  onNavYmChange,
  onNavYearChange,
  onCustomStartChange,
  onCustomEndChange,
  onCustomQuery,
}) {
  const TABS = [
    { v: 'today',  l: '오늘' },
    { v: 'month',  l: '이번달' },
    { v: 'year',   l: '올해' },
    { v: 'custom', l: '직접설정' },
  ];

  const ymOptions = useMemo(() => {
    const opts = [];
    const minY = minBuyYear || NOW_YEAR;
    for (let y = NOW_YEAR; y >= minY; y--) {
      const maxM = y === NOW_YEAR ? new Date().getMonth() + 1 : 12;
      for (let m = maxM; m >= 1; m--) {
        const v = `${y}${String(m).padStart(2, '0')}`;
        opts.push({ value: v, label: `${y}년 ${m}월` });
      }
    }
    return opts;
  }, [minBuyYear]);

  const handleDayMove = dir => {
    const cur = new Date(navDate);
    cur.setUTCDate(cur.getUTCDate() + dir);
    const nd = cur.toISOString().slice(0, 10);
    if (nd > todayStr()) return;
    onNavDateChange(nd);
  };

  return (
    <div className="mb-period-wrap">
      <div className="mb-period-tabs">
        {TABS.map(t => (
          <button
            key={t.v}
            className={`mb-period-tab${period === t.v ? ' active' : ''}`}
            onClick={() => onPeriodChange(t.v)}
          >
            {t.l}
          </button>
        ))}
      </div>

      {period === 'today' && (
        <div className="mb-period-nav">
          <button className="mb-nav-btn" onClick={() => handleDayMove(-1)}>◀</button>
          <span className="mb-nav-label" style={{ fontSize: 13 }}>{formatDay(navDate)}</span>
          <button
            className="mb-nav-btn"
            onClick={() => handleDayMove(1)}
            disabled={navDate >= todayStr()}
          >▶</button>
        </div>
      )}

      {period === 'month' && (
        <div className="mb-period-nav">
          <button className="mb-nav-btn" onClick={() => onNavYmChange(prevYm(navYm))}>◀</button>
          <span className="mb-nav-label">
            {parseInt(navYm.slice(0, 4))}년 {parseInt(navYm.slice(4))}월
          </span>
          <button
            className="mb-nav-btn"
            onClick={() => onNavYmChange(nextYm(navYm))}
            disabled={navYm >= NOW_YM}
          >▶</button>
        </div>
      )}

      {period === 'year' && (
        <div className="mb-period-nav">
          <button className="mb-nav-btn" onClick={() => onNavYearChange(navYear - 1)}>◀</button>
          <span className="mb-nav-label">{navYear}년</span>
          <button
            className="mb-nav-btn"
            onClick={() => onNavYearChange(navYear + 1)}
            disabled={navYear >= NOW_YEAR}
          >▶</button>
        </div>
      )}

      {period === 'custom' && (
        <div className="mb-custom-row">
          <select
            className="mb-custom-sel"
            value={customStart}
            onChange={e => { onCustomStartChange(e.target.value); }}
          >
            <option value="">시작월</option>
            {ymOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
          <span className="mb-custom-tilde">~</span>
          <select
            className="mb-custom-sel"
            value={customEnd}
            onChange={e => { onCustomEndChange(e.target.value); }}
          >
            <option value="">종료월</option>
            {ymOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
          <button
            className="mb-custom-btn"
            onClick={onCustomQuery}
            disabled={!customStart || !customEnd}
          >조회</button>
        </div>
      )}
    </div>
  );
}
